import { render, staticRenderFns } from "./TerminosYCondiciones.vue?vue&type=template&id=800db200&scoped=true"
import script from "./TerminosYCondiciones.vue?vue&type=script&lang=js"
export * from "./TerminosYCondiciones.vue?vue&type=script&lang=js"
import style0 from "./TerminosYCondiciones.vue?vue&type=style&index=0&id=800db200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800db200",
  null
  
)

export default component.exports